/**
 * Generated by orval v6.29.1 🍺
 * Do not edit manually.
 */
import axios from 'axios';
import type { AxiosRequestConfig, AxiosResponse } from 'axios';

import type { HentNyeSdkVersionerParams, HentOgPersisterFraTedParams } from '../../../models/generated';

export const getTidTilController = () => {
  /**
 * Initieret af TidTil.

 * @summary Henter alle danske bekendtgørelser fra TED og persisterer dem i MitUdbud.
 */
  const hentOgPersisterFraTed = <TData = AxiosResponse<string>>(
    params: HentOgPersisterFraTedParams,
    options?: AxiosRequestConfig
  ): Promise<TData> => {
    return axios.get(`/tidTil:hentOgPersisterFraTed`, {
      ...options,
      params: { ...params, ...options?.params }
    });
  };
  /**
 * Initieret af TidTil.

 * @summary Henter nye minor versioner af ted-eforms-sdk.
 */
  const hentNyeSdkVersioner = <TData = AxiosResponse<string>>(params: HentNyeSdkVersionerParams, options?: AxiosRequestConfig): Promise<TData> => {
    return axios.get(`/tidTil:hentNyeSdkVersioner`, {
      ...options,
      params: { ...params, ...options?.params }
    });
  };
  return { hentOgPersisterFraTed, hentNyeSdkVersioner };
};
export type HentOgPersisterFraTedResult = AxiosResponse<string>;
export type HentNyeSdkVersionerResult = AxiosResponse<string>;
